import request from '@/router/axios'

export function pendingTaskList (obj) {
  return request({
    url: '/dotadmin/dotRisk/pendingTaskList',
    method: 'post',
    data: obj
  })
}

export function updatePeInfo (obj) {
  return request({
    url: '/dotadmin/dotRisk/updatePeInfo',
    method: 'post',
    data: obj
  })
}

export function confirmStartPe (obj) {
  return request({
    url: '/dotadmin/dotRisk/confirmStartPe',
    method: 'post',
    data: obj
  })
}

export function cancelFlow (obj) {
  return request({
    url: '/dotadmin/dotRisk/cancelFlow',
    method: 'post',
    data: obj
  })
}

export function getTaskReserveTr (obj) {
  return request({
    url: '/dotadmin/dotRisk/getTaskReserveTr',
    method: 'post',
    data: obj
  })
}

export function orderAddList (obj) {
  return request({
    url: '/dotadmin/dotRisk/orderAddList',
    method: 'post',
    data: obj
  })
}

export function addRiskQueue (obj) {
  return request({
    url: '/dotadmin/dotRisk/addRiskQueue',
    method: 'post',
    data: obj
  })
}

export function dotFlowStatusEnum() {
  return request({
    url: '/dotadmin/dotRisk/dotFlowStatusEnum',
    method: 'get',
  })
}

export function addLog (obj) {
  return request({
    url: '/dotadmin/dotRisk/addLog',
    method: 'post',
    data: obj
  })
}
